import React from "react";
import Modal from "Utils/Modal";

export default function ForceSignoutModal(props) {
  return (
    <Modal
      open={props.open}
      toggle={props.toggle}
      title="You've Been Signed Out"
    >
      <p>Your login is being used on a different device.</p>
      <p>Please select Sign Back In to log back in on this device.</p>
      <button className="btn fullWidth mtLg" onClick={props.toggle}>
        Sign Back In
      </button>
    </Modal>
  );
}
